import type { ReactNode } from 'react'

import styles from './controls.module.scss'

type SeriesCheckboxProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  children: ReactNode
  weight?: number
  disabled?: boolean
}

export const SeriesCheckbox = ({
  checked,
  onChange,
  children,
  weight,
  disabled,
}: SeriesCheckboxProps) => (
  <button
    type='button'
    role='checkbox'
    aria-checked={checked}
    disabled={disabled}
    className={styles.check}
    style={weight ? { fontWeight: weight } : undefined}
    onClick={() => onChange(!checked)}>
    <span className={checked ? `${styles.box} ${styles.boxOn}` : styles.box} aria-hidden='true'>
      {checked ? '✓' : null}
    </span>
    {children}
  </button>
)
